<template lang="pug">
article.message.is-warning.margin-top-md(v-if="code.users && code.users.length === 0")
	.message-body(v-if="code.code")
		| {{ $t('codes.no_users_code', { code: code.code }) }}
		br
		| {{ $t('codes.code_help') }}
	.message-body(v-else)
		| {{ $t('codes.no_users') }}
		br
		| {{ $t('codes.code_help') }}

article.message.is-warning.margin-top-md(v-else-if="code.expiration && daysDifference(code.expiration) <= daysLimit")
	.message-body
		| {{ $t('codes.explain') }}
		br
		| {{ $t('codes.expiration', { time: getDate(code.expiration) }) }}
</template>

<script>
export default {
	data() {
		return {
			daysLimit: 30
		}
	},
	props: {
		code: {
			type: Object,
			required: true
		}
	},
	methods: {
		getDate(timestamp) {
			const d = new Date(timestamp * 1000)
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
			const month = months[d.getMonth()]

			return d.getDate() + ' ' + this.$t('time.month.' + month) + ' ' + d.getFullYear()
		},
		daysDifference(timestamp) {
			const time = Math.floor(new Date().getTime() / 1000)
			const diff = timestamp - time

			return Math.ceil(diff / 86400)
		}
	}
}
</script>
